import { BaseAudioRecordingAppEventOperation } from "./BaseAudioRecordingAppEventOperation";
import { AudioRecordingAppEventOperationKind } from "@/store/sync/operations/types";

export class MarkVoiceReconnectedAudioRecordingOperation extends BaseAudioRecordingAppEventOperation {
  get operationKind(): AudioRecordingAppEventOperationKind {
    return "MARK_VOICE_RECONNECTED_AUDIO_RECORDING";
  }

  // Voice reconnect doesn't change model status fields
  // The event is tracked for observability purposes
}
